import { FilterOutlined } from '@ant-design/icons';
import { Empty, Spin } from 'antd';
import { getHotCity, getSearchCond, initUrlQuery, searchAll } from 'api/jjzq';
import { getSelectCascadeArea } from 'api/user';
import AntdArrowIcon from 'comps/AntdArrowIcon';
import {
  arrayToQueryParam,
  DayLeft,
  defaultValue,
  queryParamToArray,
  TenderDataItem,
  toServerParam,
  useQuery,
} from 'comps/Jjzq';
import SearchConditionDrawerForJjzq, {
  Item,
  SubItem,
  Value,
} from 'comps/SearchConditionDrawerForJjzq';
import SearchInput from 'comps/SearchInput';
import { useGtZeroEffect } from 'hooks/useGtZeroEffect';
import { tabs } from 'libs/cons';
import { dateFormat } from 'libs/utils';
import { useRouter } from 'next/router';
import { typeMap } from 'pages/pages/jjzq';
import { useCallback, useEffect, useRef, useState } from 'react';
import { cls } from 'reactutils';
const FilterBarHeight = 50;
// 支持搜索页使用该组件不能进行服务端渲染(接口全部移到组件内请求)
export default function JjzqH5Content({ extraHeight, clearComps }) {
  const [indexData, setIndexData] = useState({});
  const [condition, setCondition] = useState({});
  const { query } = useQuery();
  const type = (query.type ? query.type : initUrlQuery.type) as string;
  const getHotCityData = async () => {
    let res = await getHotCity();
    if (res.code === 200) {
      setIndexData(res?.data ?? {});
    }
  };
  const getSearchCondData = async (type) => {
    let res = await getSearchCond({
      query: {
        type,
      },
    });
    if (res.code === 200) {
      setCondition(res?.data ?? {});
    }
  };

  useEffect(() => {
    getHotCityData();
    getSearchCondData(typeMap[type]);
  }, [type]);
  return (
    <>
      <ConditionsMobile condition={condition} indexData={indexData} clearComps={clearComps} />
      <ListContentMobile extraHeight={extraHeight} />
    </>
  );
}

export function Tabs({ tabs = [], activeKey, onChange }) {
  return (
    <>
      <div className="tabs">
        {tabs?.map((item) => {
          return (
            <div
              key={item.key}
              className={cls('tab-item', item.key === activeKey && 'active')}
              onClick={() => {
                onChange(item.key);
              }}
            >
              <div className="tab-inline">{item.name}</div>
            </div>
          );
        })}
      </div>
      <style jsx>{`
        .tabs {
          display: flex;
          height: 43px;
          padding-top: 10px;
          background-color: #fff;
        }
        .tabs .tab-item {
          width: 50%;

          font-size: 16px;
          color: #595959;
        }
        .tabs .tab-inline {
          position: relative;
          height: 100%;
          text-align: center;
          margin: 0 34px;
        }
        .tabs .tab-item.active {
          color: var(--primaryColor);
          font-weight: 600;
        }
        .tabs .tab-item.active .tab-inline:after {
          content: "";
          position: absolute;
          bottom: 0;
          right: 0;
          height: 3px;
          width: 100%;
          background: var(--primaryColor);
          border-radius: 2px;
        }
      `}</style>
    </>
  );
}

function ConditionsMobile({ condition, indexData, clearComps = true }: any) {
  const reservedComps = !clearComps;
  const { hotCategories = [], hotAreas = [] } = indexData;
  const [allAreas, setAllAreas] = useState([]);
  useEffect(() => {
    getSelectCascadeArea().then((resp) => {
      if (resp?.code === 200) {
        setAllAreas(resp?.data ?? []);
      }
    });
  }, []);

  const { query, push } = useQuery(true);
  const [showDrawer, setShowDrawer] = useState(false);

  function changeType(type) {
    push(
      {
        keyword: query.keyword as string,
        type: type,
        // 清空以下参数
        sortType: '',
        status: '',
      },
      true,
    );
  }

  function changeSearch(name = '') {
    push(
      {
        keyword: name,
      },
      true,
    );
  }

  // 中标公告tab不展示【即将截止】和【只看进行中】
  function hideSomeFilter(query: JjzqQueryObj) {
    return query.type === '2';
  }
  function genConditionList(): Item[] {
    function transform<T extends { children?: T[] }>(from: T, conv: (from: T) => SubItem): SubItem {
      const result = conv(from);
      if (from?.children?.length > 0) {
        result.children = from.children?.map((c) => transform(c, conv));
      }
      return result;
    }

    const result: Item[] = [
      {
        type: 'checkbox',
        title: '状态',
        show: !hideSomeFilter(query),
        prop: 'status',
        labelKey: 'name',
        hasMoreBtn: false,
        hotSubList: [
          {
            name: '只看进行中',
            sysNo: '1',
          },
        ],
      },
      {
        type: 'checkbox',
        title: '分类',
        prop: 'categories',
        labelKey: 'name',
        hotSubList: hotCategories
          ?.map((c) =>
            transform(c, (c) => {
              return {
                name: c.label,
                sysNo: c.value,
              };
            }),
          )
          .slice(0, 8),
        show: true,
        hasMoreBtn: true,
        totalSubList: condition?.categories?.map((c) =>
          transform(c, (c) => {
            return {
              name: c.label,
              sysNo: c.value,
            };
          }),
        ),
      },
      {
        type: 'checkbox',
        show: true,
        title: '地区',
        hasMoreBtn: true,
        prop: 'area',
        labelKey: 'label',
        hotSubList: hotAreas
          ?.map((a) =>
            transform(a, (a) => {
              return {
                label: a.label,
                sysNo: a.value,
              };
            }),
          )
          ?.slice(0, 8),
        totalSubList: allAreas?.map((a) =>
          transform(a, (a) => {
            return {
              label: a.label,
              sysNo: a.sysNo,
            };
          }),
        ),
      },
    ];

    return result;
  }

  const drawerValue: Value = {
    area: queryParamToArray(query.area as any),
    categories: queryParamToArray(query.categories as any),
  };
  if (query.status) {
    drawerValue.status = [query.status as string];
  }
  const keyword = (query.keyword ? query.keyword : '') as string;
  const type = (query.type ? query.type : initUrlQuery.type) as string;
  const advancedFilterOn = query.area || query.categories || (query.status && query.type == '1');
  return (
    <>
      <div className={cls('cm')}>
        {reservedComps && (
          <SearchInput
            isSearchSku
            placeholder="搜索商机"
            onSearch={changeSearch}
            initVal={keyword}
          />
        )}
        {reservedComps && <Tabs tabs={tabs} activeKey={type} onChange={changeType} />}
        <div className="filters">
          <span
            className={query.sortType !== '2' && 'active'}
            onClick={() => {
              push({
                ...query,
                sortType: '1',
              });
            }}
          >
            最新发布
          </span>
          {hideSomeFilter(query) ? (
            <span />
          ) : (
            <span
              className={query.sortType === '2' && 'active'}
              onClick={() => {
                push({
                  ...query,
                  sortType: '2',
                });
              }}
            >
              即将截止
            </span>
          )}
          <span
            className={cls('advanced', advancedFilterOn ? 'on' : null)}
            onClick={() => setShowDrawer(true)}
          >
            筛选
            <FilterOutlined />
          </span>
        </div>
        <SearchConditionDrawerForJjzq
          visible={showDrawer}
          conditionList={genConditionList()}
          value={drawerValue}
          onClose={() => setShowDrawer(false)}
          onChange={(value, type) => {
            type === 'reset'
              ? push({
                  ...query,
                  status: value.status?.[0],
                  area: arrayToQueryParam(value.area as any),
                  categories: arrayToQueryParam(value.categories as any),
                  level1: '',
                  level2: '',
                })
              : push({
                  ...query,
                  status: value.status?.[0],
                  area: arrayToQueryParam(value.area as any),
                  categories: arrayToQueryParam(value.categories as any),
                });
          }}
        />
      </div>
      <style jsx>{`
        .cm {
          background-color: #ffffff;
        }
        .title {
          font-size: 19px;
          color: #ffffff;
          text-align: center;
          padding-top: 38px;
          padding-bottom: 25px;
          line-height: 1;
        }
        .search-ops {
          position: relative;
          padding: 0 16px;
        }
        .search-ops :global(.ant-input) {
          height: 32px;
          margin: auto;
          border-radius: 16px;
          font-size: 14px;
          line-height: 32px;
        }
        .search-ops :global(.ant-btn) {
          position: absolute;
          width: 54px;
          height: 26px;
          top: 3px;
          right: 20px;
          padding: 0;
          border-radius: 13px;
          background: #ff9f1c;
          color: #ffffff;
          border: none;
        }

        .filters {
          position: relative;
          border-top: 1px solid #e5e5e5;
          box-shadow: 0px 4px 7px -3px rgba(0, 0, 0, 0.13);
          z-index: 1;
        }
        .filters > span {
          width: 33%;
          padding: 13px 29px;
          margin: 0;
          text-align: center;
          font-size: 14px;
          display: inline-block;
        }
        .filters > span.active {
          color: var(--fontPrimaryColor);
        }
        .cm
          :global(.ant-dropdown-menu.extra-tabs)
          :global(.ant-dropdown-menu-item) {
          font-size: 16px;
        }
        .advanced.on {
          color: var(--fontPrimaryColor);
        }
        .cm :global(.ant-tabs-nav) {
          display: block;
        }
      `}</style>
    </>
  );
}

function ListContentMobile({ extraHeight }) {
  const { query } = useQuery(true);
  // 只有在组件 ConditionsMobile 里修改查询条件total才会变化，加载更多不会
  const [total, setTotal] = useState(0);
  const [items, setItems] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const changeQueryGetData = (pageSize?) => {
    return new Promise(async (resolve) => {
      try {
        let json = {
          ...toServerParam(query),
          // 所有查询条件变更后都请求首页数据
          pageNo: 1,
        };
        if (pageSize) {
          json.pageSize = pageSize;
        }
        setLoading(true);
        let res = await searchAll({
          method: 'POST',
          json,
        });
        if (res?.code === 200) {
          setItems(res?.data?.datas ?? []);
          setTotal(res?.data?.total ?? 0);
          resolve('successful');
        }
      } finally {
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    let timerId = null;
    (async () => {
      const preItemData = sessionStorage.getItem(JjzqItemStorageKey);
      const preItemDataJson = preItemData && JSON.parse(preItemData);
      // 定位之前选中的
      if (preItemDataJson?.currPage && preItemDataJson?.scrollY) {
        const { currPage, scrollY } = preItemDataJson;
        // 一次性请求所有数据
        await changeQueryGetData(currPage * initUrlQuery.pageSize);
        // 最好等待一会儿，数据加载完成并不等于DOM已经渲染
        timerId = setTimeout(() => {
          timerId = null;
          setCurrPage(currPage);
          scrollRef?.current?.scrollTo({ top: scrollY });
          sessionStorage.removeItem(JjzqItemStorageKey);
        }, 50);
      } else {
        changeQueryGetData();
      }
    })();

    return () => {
      timerId && clearTimeout(timerId);
    };
  }, []);

  // 除加载更多外，其余操作都在这里请求数据(首次不加载)
  useGtZeroEffect(() => {
    changeQueryGetData();
    // 搜索页有多余query，不能 watch query 进行查询
  }, [query.keyword, query.type, query.categories, query.sortType, query.area, query.status]);

  async function loadMore() {
    const nextPage = currPage + 1;
    setLoading(true);
    try {
      let res = await searchAll({
        method: 'POST',
        json: toServerParam({ ...query, pageNo: +nextPage }, initUrlQuery.pageSize, true),
      });
      if (res.code === 200 && Array.isArray(res?.data?.datas)) {
        // 只有请求成功才 setCurrPage(nextPage)
        setItems([...items, ...res?.data?.datas]);
        setCurrPage(nextPage);
      }
    } finally {
      setLoading(false);
    }
  }

  const getScrollTop = useCallback(() => {
    return scrollRef?.current?.scrollTop ?? 0;
  }, []);

  return (
    <>
      <div className="lcm" ref={scrollRef}>
        {items?.length === 0 ? (
          <div className="empty-container">
            <Empty description="暂无数据" />
          </div>
        ) : (
          <Spin spinning={loading}>
            <div className="items">
              {items?.map((item, i) => {
                return (
                  <div className="card-container" key={i}>
                    <NoticeItemH5 data={{ ...item, currPage }} getScrollTop={getScrollTop} />
                  </div>
                );
              })}
            </div>
            <div className="bottom">
              {items?.length < total && (
                <div onClick={loadMore} className="more">
                  加载更多
                  <AntdArrowIcon direction="down" />
                </div>
              )}
            </div>
          </Spin>
        )}
      </div>
      <style jsx>{`
        .lcm {
          height: calc(100vh - ${+extraHeight + FilterBarHeight}px);
          background: var(--pageBgColor);
          overflow-y: auto;
        }
        .empty-container {
          padding-top: 75px;
        }
        .more {
          text-align: center;
          color: var(--primaryColor);
          font-size: 13px;
          padding: 13px 0;
        }
        .more :global(svg) {
          position: relative;
          top: -1px;
          left: 4px;
          fill: var(--primaryColor);
          font-size: 10px;
        }
        .bottom {
          min-height: 33px;
        }
        .bottom :global(i) {
          font-size: 10px;
          margin-left: 4px;
        }

        .items .card-container {
          padding: 9px 16px 0;
        }
      `}</style>
    </>
  );
}
export const JjzqItemStorageKey = 'm-mall-jjzq-click-item';
export function NoticeItemH5({
  data,
  getScrollTop,
}: {
  data: TenderDataItem;
  getScrollTop: Function;
}) {
  const { push } = useRouter();
  const { query } = useQuery(true);
  const type = (query.type ? query.type : initUrlQuery.type) as string;
  const currPage = data.currPage ?? 1;
  const areaName = data?.areaName ? data?.areaName.replace(/,/g, '、') : defaultValue;

  const onClickItem = useCallback(() => {
    sessionStorage.setItem(
      JjzqItemStorageKey,
      JSON.stringify({
        currPage,
        scrollY: getScrollTop(),
      }),
    );
    const pathname = '/pages/jjzq/detail';
    const { sysNo } = data;
    // location.href = `${pathname}?sysNo=${sysNo}&type=${type}`
    push(`${pathname}?sysNo=${sysNo}&type=${type}`);
  }, [currPage, data, type, getScrollTop]);
  return (
    <>
      <div className={cls('recommendation-item')} onClick={onClickItem}>
        <h5
          className="title"
          title={data.oldName}
          dangerouslySetInnerHTML={{ __html: data.name }}
        />
        <div className="tags">
          {data.category && (
            <span
              className="tag"
              title={data.oldCategory}
              dangerouslySetInnerHTML={{ __html: data.category }}
            />
          )}
          <StatusTag deadline={data?.deadline} type={type} />
        </div>
        <div className="recommendation-body">
          {type === '1' && <DayLeft deadline={data.deadline} />}
          <p className="main-p">
            <span className="main-key">区域</span>
            <span className="black" title={areaName}>
              {areaName}
            </span>
          </p>
          {type === '1' && (
            <p className="main-p">
              <span className="main-key">截止时间</span>
              <span className="black">{dateFormat(data.deadline, 'YYYY-MM-DD HH:mm')}</span>
            </p>
          )}
          {type === '2' && (
            <p className="main-p">
              <span className="main-key">发布时间</span>
              <span className="black">{dateFormat(data.issueDate, 'YYYY-MM-DD HH:mm')}</span>
            </p>
          )}
        </div>
      </div>
      <style jsx>{`
        .recommendation-item {
          display: block;
          padding: 16px;
          color: #333;
          background: #fff;
          box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.04);
          border-radius: 4px;
        }
        .recommendation-item .title {
          margin-bottom: 10px;
          font-size: 15px;
          line-height: 22px;
          color: #333333;
          font-weight: 500;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        .black {
          color: #151515;
        }
        .org-name {
          font-size: 12px;
          color: #333333;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .main-p {
          height: 24px;
          line-height: 24px;
        }
        .main-key {
          display: inline-block;
          margin-right: 10px;
        }
        .tag-img {
          position: absolute;
          width: 81px;
          height: 76px;
          margin-top: -200px;
          margin-left: 270px;
        }
        .recommendation-item .tags {
          margin-bottom: 12px;
          height: 22px;
        }

        .recommendation-item .tag {
          background: #f3f3f3;
          line-height: 22px;
          padding: 0 12px;
          font-size: 12px;
          color: #848282;
          letter-spacing: 0;
          display: inline-block;
          margin-right: 5px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .recommendation-body {
          position: relative;
          font-size: 12px;
          color: #8c8d8d;
          letter-spacing: 0;
          line-height: 22px;
        }
        .recommendation-body p {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 0;
        }
        .recommendation-body :global(.deadline) {
          width: auto;
          bottom: 2px;
        }
      `}</style>
    </>
  );
}

export function StatusTag({ deadline, type = '1' }) {
  const commonStyle: any = {
    float: 'right',
    fontSize: '12px',
    width: '58px',
    height: '22px',
    lineHeight: '20px',
    textAlign: 'center',
  };
  if (type === '2') {
    return (
      <span
        style={{
          ...commonStyle,
          color: '#fff',
          background: '#CFCFCF',
          border: '0.5px solid #fff',
        }}
      >
        中标公示
      </span>
    );
  }
  // 小于当前时间 或 不存在都当作已截止
  if (!deadline || Date.now() > deadline) {
    return (
      <span
        style={{
          ...commonStyle,
          color: '#fff',
          background: '#CFCFCF',
          border: '0.5px solid #fff',
        }}
      >
        已截止
      </span>
    );
  } else {
    return (
      <span
        style={{
          ...commonStyle,
          color: 'var(--primaryColor)',
          background: 'rgba(43,109,206,0.10)',
          border: '0.5px solid var(--primaryColor)',
        }}
      >
        进行中
      </span>
    );
  }
}
